export default function TrustSection() {
  const stats = [
    {
      value: '+20.000',
      label: 'utilizadores ativos em Portugal e Brasil',
      icon: 'ri-group-line',
      image: 'https://readdy.ai/api/search-image?query=Diverse%20group%20of%20young%20people%20browsing%20fashion%20products%20on%20smartphones%20and%20laptops%20at%20a%20bright%20modern%20co%20working%20space%20with%20large%20windows%20green%20plants%20and%20wooden%20tables%20natural%20daylight%20streaming%20in%20creating%20warm%20inviting%20atmosphere%20candid%20lifestyle%20photography%20genuine%20expressions%20casual%20contemporary%20clothing%20mix%20of%20earthy%20and%20pastel%20colors%20European%20creative%20workspace%20aesthetic%20collaborative%20energetic%20mood%20authentic%20unposed%20moment&width=600&height=400&seq=trust-users-v2&orientation=landscape',
    },
    {
      value: '+5.000',
      label: 'produtos organizados e verificados',
      icon: 'ri-checkbox-circle-line',
      image: 'https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20neatly%20organized%20fashion%20products%20on%20white%20marble%20surface%20including%20folded%20garments%20accessories%20and%20shoes%20arranged%20in%20tidy%20grid%20pattern%20soft%20diffused%20studio%20lighting%20from%20above%20clean%20minimalist%20product%20catalog%20aesthetic%20varied%20earthy%20tones%20sage%20green%20dusty%20rose%20warm%20terracotta%20organized%20systematic%20arrangement%20high%20detail%20textile%20textures%20visible%20professional%20inventory%20management%20mood&width=600&height=400&seq=trust-products-v2&orientation=landscape',
    },
    {
      value: '+1.000',
      label: 'vendedores confiáveis recomendados',
      icon: 'ri-shield-star-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20handshake%20between%20two%20people%20over%20a%20modern%20glass%20desk%20with%20laptop%20and%20documents%20visible%20warm%20natural%20office%20lighting%20from%20floor%20to%20ceiling%20windows%20clean%20contemporary%20corporate%20aesthetic%20genuine%20partnership%20and%20trust%20atmosphere%20soft%20focus%20background%20with%20blurred%20office%20interior%20navy%20and%20warm%20wood%20tones%20professional%20yet%20approachable%20mood%20authentic%20business%20relationship%20moment&width=600&height=400&seq=trust-sellers-v2&orientation=landscape',
    },
  ];

  return (
    <section className="relative w-full bg-gradient-to-b from-primary-800 via-primary-900 to-primary-950 py-20 md:py-28 overflow-hidden">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.3) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }}></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
            {/* Left - Text content */}
            <div className="lg:col-span-3">
              <span className="inline-flex items-center gap-2 text-xs font-semibold text-accent-400 uppercase tracking-widest mb-6">
                <span className="w-6 h-px bg-accent-500"></span>
                Confiança
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
                CSSBuy Spreadsheet:<br />
                Links Verificados para<br />
                Portugal e Brasil
              </h2>
              <p className="text-white/65 text-base leading-relaxed mb-8 max-w-xl">
                O CSSBuy Spreadsheet reúne milhares de links organizados em um único lugar. Cada produto é verificado manualmente pela nossa equipa para garantir que você encontre apenas itens de qualidade. Atualizamos nossa planilha diariamente com novos produtos e removemos links quebrados.
              </p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3 bg-accent-500 text-foreground-950 text-sm font-semibold rounded-full hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                buy it now
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
            </div>

            {/* Right - Stats with images */}
            <div className="lg:col-span-2 flex flex-col gap-5">
              {stats.map((stat) => (
                <div
                  key={stat.value}
                  className="group relative bg-white/8 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/10 hover:border-white/20 transition-all duration-300 cursor-default"
                >
                  {/* Image background */}
                  <div className="absolute inset-0">
                    <img
                      src={stat.image}
                      alt={stat.label}
                      className="w-full h-full object-cover object-top opacity-30 group-hover:opacity-40 transition-opacity duration-300"
                      loading="lazy"
                    />
                  </div>
                  {/* Content */}
                  <div className="relative z-10 p-6 flex items-center gap-4">
                    <div className="w-11 h-11 rounded-full bg-accent-500/20 flex items-center justify-center flex-shrink-0">
                      <i className={`${stat.icon} text-accent-400 text-lg`}></i>
                    </div>
                    <div>
                      <p className="text-3xl md:text-4xl font-bold text-white mb-0.5">{stat.value}</p>
                      <p className="text-white/55 text-xs">{stat.label}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}